import React, { useState, useMemo, createContext, useContext } from "react"

const FeaturedVideosContext = createContext(null)

export const FeaturedVideosProvider = ({ ...props }) => {
  const [showFeaturedVideos, setShowFeaturedVideos] = useState(true)

  const value = useMemo(() => {
    // We only allow changing the value from true to false
    const setValue = (val) => {
      if (showFeaturedVideos && !val) {
        setShowFeaturedVideos(false)
      }
    }

    return { showFeaturedVideos, setShowFeaturedVideos: setValue }
  }, [showFeaturedVideos])

  return <FeaturedVideosContext.Provider value={value} {...props} />
}

export const useFeaturedVideos = () => {
  const context = useContext(FeaturedVideosContext)
  if (!context) {
    throw new Error(`useFeaturedVideos must be used within a FeaturedVideosProvider`)
  }
  return context
}
